<template>
    <v-flex xs12>
        <crm-entry-edit-dialog
            v-model="edit"
            :incident="incident"
            :entry="entry"
        />
        <v-card
            flat
            rounded
            class="crm-journal-card"
            :class="entryClass"
        >
            <crm-entry-readonly
                :entry     = "entry"
                :incident  = "incident"
                @edit      = "onEdit"
                @deleted   = "onDeleted"
                @undeleted = "onUnDeleted"
            />
        </v-card>
    </v-flex>
</template>

<script>

import Crm              from "@/modules/crm/service/Crm.ts";
import CrmEntryReadonly from "@/modules/crm/components/main/CrmEntryReadonly";
import CrmEntryEditDialog from "@/modules/crm/components/main/CrmEntryEditDialog";

export default {
    name: "CrmEntry",

    components: {
        CrmEntryEditDialog,
        CrmEntryReadonly,
    },

    props: {
        entry: {
            required: true,
            type    : Object
        },
        incident: {
            required: true,
            type    : Object
        }
    },

    data: () => ({
        edit: false,
    }),

    computed: {
        entryClass () {
            if (this.entry.deleted) {
                return 'crm-journal-deleted';
            }

            if (this.edit) {
                return 'crm-journal-edit';
            }

            return 'crm-journal-noedit';
        },

        isPhone () {
            return this.entry.type.id === Crm.journal.type.phone;
        },

        isReminder () {
            return this.entry.type.id === Crm.journal.type.reminder;
        },

        isPostponement () {
            return this.entry.type.id === Crm.journal.type.postponement;
        },
    },

    methods: {
        /**
         * Switch to edit mode.
         */
        onEdit  () {
            this.edit = true;
            this.$emit(Crm.events.edit, this.entry);
        },

        /**
         * Finish edit mode after the entry was saved.
         */
        onSaved (saved) {
            this.edit = false;
            if (saved) {
                this.$emit(Crm.events.saved);
            }
        },

        /**
         * Finish edit mode after the entry was deleted.
         */
        onDeleted: function () {
            this.edit = false;
            this.$emit(Crm.events.deleted);
        },

        onUnDeleted: function () {
            this.edit = false;
            this.$emit(Crm.events.undeleted);
        },

        /**
         * Finish edit mode after cancelation.
         */
        onCancel () {
            this.edit = false;
        },

        /**
         * The edit mode for an entry starts. All other entries have to leave the editor mode.
         * @param editEntry the entry to be edited.
         */
        startEdit (editEntry) {
            if (editEntry !== null && this.entry.id === editEntry.id) {
                this.scrollIntoView()
            } else if (this.edit === true) {
                this.$refs.editor.onSave();
            }
        },

        /**
         * Make the journal entry editor visible.
         */
        async scrollIntoView () {
            await this.$nextTick(() => {
            //    this.$el.scrollIntoView();
            });
        }
    }
}
</script>

<style scoped>

.crm-journal-card {
    padding: 10px;
    border-radius: 5px!important;
    width: 100%;
}

.crm-journal-deleted {
    border-style: solid;
    border-width: 1px;
    border-color: red!important;
}

</style>